import { Component } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';

@Component({
  selector: 'app-my-leaves',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [{ provide: TabComponent, useExisting: MyLeavesComponent }],
  templateUrl: './my-leaves.component.html',
  styleUrl: './my-leaves.component.scss',
})
export class MyLeavesComponent extends TabComponent {
  override name: string = this.dictionaryService.get('MyLeaves');
  public async main(): Promise<void> {}
}
